<template>
  <article class="analysisA">
    <ul class="tab-service-detail">
      <li v-for="item in tabList" @click="onShiftTab(item)" :class="{on:item.on}" :key="item.id">
        <a href="javascript:void(0);">{{ item.name }}</a>
      </li>
    </ul>
    <div class="blank"></div>
    <div class="car-all">
      <cell title="销售顾问" class="top-title" v-if="this.tabList[0].on && this.tabList[0].id === 'date'">
        <span slot="after-title" class="title-date">{{"|&nbsp;&nbsp;" + day }}</span>
        <button
          slot="child"
          :class="{'btn-select': flagA, 'btn-default': !flagA}"
          @click="onChangeTab({filter: 'today', bool: true})"
        >
          今天
        </button>
        <button
          slot="child"
          :class="[{'btn-select': !flagA, 'btn-default': flagA}, 'btn-margin']"
          @click="onChangeTab({filter: 'yestoday', bool: false})"
        >
          昨天
        </button>
      </cell>
      <cell title="销售顾问" class="top-title" v-else>
        <span slot="after-title" class="title-date">{{"|&nbsp;&nbsp;" + day }}</span>
        <button
          slot="child"
          :class="{'btn-select': flagA, 'btn-default': !flagA}"
          @click="onChangeTab({filter: 'this_month', bool: true})"
        >
          本月
        </button>
        <button
          slot="child"
          :class="[{'btn-select': !flagA, 'btn-default': flagA}, 'btn-margin']"
          @click="onChangeTab({filter: 'last_month', bool: false})"
        >
          上个月
        </button>
      </cell>
      <!--销售指标统计-->
      <p class="table-title">销售指标统计</p>
      <a-card
        ref="saleQuota"
        config="saleQuota"
        first-field="sale"
        :params="params"
      >
        <th slot="title">销售顾问</th>
      </a-card>
      <!--销售顾问营销漏斗分析-->
      <div class="funnel-analysis">
        <p class="table-title">销售顾问营销分析</p>
        <div class="tabs box">
          <checker default-item-class="checker" selected-item-class="checker-selected" v-model="saleValue">
            <checker-item
              value=""
              key=""
              @on-item-click="onChangeChecker()"
            >
              全部
            </checker-item>
            <checker-item
              v-for="(item, index) in SalesList"
              :value="item.id"
              :key="index"
              @on-item-click="onChangeChecker(item)"
            >
              {{ item.name }}
            </checker-item>
          </checker>
        </div>
        <div class="table-pad">
          <table class="table-list" cellspacing="0" cellpadding="0">
            <thead>
            <tr>
              <th colspan="2"></th>
              <th>到店</th>
              <th>草签数</th>
              <th>成交数</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in SaleFunnelList" :key="index">
              <td v-if="item.first_type && index === 0"  :rowspan="firstArrived">
                <span class="one-line">{{ item.arrived_type }}</span>
              </td>
              <td v-if="!item.first_type" colspan="2">{{ item.arrived_type }}</td>
              <td v-if="item.first_type"
                  :class="{'first-type': index === 0 && item.first_type}"
              >
                <span>{{ item.first_type }}</span>
              </td>
              <td><span>{{ item.arrived }}</span></td>
              <td><span>{{ item.review }}</span></td>
              <td><span>{{ item.deal }}</span></td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
import util from '../../common/util'
import ACard from './components/ACard'
import {
  Cell,
  Checker,
  CheckerItem
} from '@lx-frontend/cvux'

export default {
  components: {
    Cell,
    Checker,
    CheckerItem,
    ACard
  },
  data() {
    return {
      storeId: this.$route.query.store_id,
      flagA: true,
      day: util.formatTime(new Date(), 'yyyy-MM'), // 获取当前日期
      params: {
        filter: 'this_month',
        store_id: this.$route.query.store_id
      },
      tabList: [{
        id: 'date',
        name: '日',
        on: false
      }, {
        id: 'month',
        name: '月',
        on: true
      }],
      firstArrived: 0, // 首次到店个数
      saleValue: '', // 设置选中默认值为全部
      SalesList: [], // 所有的销售顾问
      SaleFunnelList: [] // 销售顾问营销漏斗分析
    }
  },
  created() {
    this.querySales()
    this.querySaleFunnel('')
    this.getData()
    this.getType()
  },
  methods: {
    getType () {
      const type = this.$route.query.type
      let index = 1

      if (type) {
        index = parseFloat(type)
      }

      this.onShiftTab(this.tabList[index])
    },
    getData () {
      this.querySales()
      this.querySaleFunnel('')
    },
    getCurrentTime () {
      let date = new Date()
      switch (this.params.filter) {
        case 'last_month':
          let lastMonty = new Date(date.getFullYear(), date.getMonth() - 1, date.getDate())
          this.day = util.formatTime(lastMonty, 'yyyy-MM')
          break
        case 'yestoday':
          let yesterday = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1)
          this.day = util.formatTime(yesterday, 'yyyy-MM-dd')
          break
        case 'today':
          this.day = util.formatTime(date, 'yyyy-MM-dd')
          break
        default:
          this.day = util.formatTime(date, 'yyyy-MM')
      }
    },
    onShiftTab(item) {
      this.tabList.forEach((tab) => {
        if (item.id === tab.id) {
          tab.on = true
        } else {
          tab.on = false
        }
      })
      this.flagA = true
      if (item.on && item.id === 'date') {
        this.params.filter = 'today'
      } else {
        this.params.filter = 'this_month'
      }

      this.getData()
      this.getCurrentTime()
    },
    onChangeTab(params) {
      this.flagA = params.bool
      this.params.filter = params.filter
      this.getData()
      this.getCurrentTime()
    },
    onChangeChecker (item) {
      if (item) {
        this.querySaleFunnel(item.id)
      } else {
        this.querySaleFunnel('')
      }
    },
    querySales () {
      let params = {
        store_id: this.storeId
      }
      this.$rest.dataAnalysis.getSales(params).then(res => {
        if (res.code === 0) {
          this.SalesList = res.data
        }
      })
    },
    querySaleFunnel (saleId) {
      let params = {
        filter: this.params.filter, // 日月
        sale: saleId, // 销售顾问 id
        store_id: this.storeId
      }
      this.$rest.dataAnalysis.getSaleFunnel(params).then(res => {
        if (res.code === 0) {
          let num = 0
          const lists = res.data
          lists.forEach(data => {
            if (data.arrived_type === '首次到店') {
              num++
            }
          })
          this.SaleFunnelList = lists
          this.firstArrived = num
        } else {
          this.showToast(res.message)
        }
      })
    }
  }
}
</script>

<style lang="less">
  @import "../../stylesheets/modules/data/carData.less";
  @import "../../stylesheets/modules/data/funnelAnalysis.less";
  .one-line {
    display: block;
    width: 25px;
    line-height:28px;
    white-space: normal!important;
  }
  .colspan {
    padding: 0!important;
    text-align: center!important;
  }
</style>
